var _style, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardNoIconGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 190 120",
    style: {
      enableBackground: "new 0 0 190 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000104678410070345873970000016029692456088050310_);}\n\t.st3{opacity:0.56;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{opacity:0.6;}\n\t.st6{opacity:0.3;}\n\t.st7{opacity:0.14;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 60.8968,
    x2: 190,
    y2: 60.8968,
    gradientTransform: "matrix(1 0 0 -1 0 121)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E27AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9F77D6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.3,0.2h173.5c4.6,0,8.3,3.7,8.3,8.3v103.2c0,4.6-3.7,8.3-8.3,8.3H8.3c-4.6,0-8.3-3.7-8.3-8.3V8.5 C0,3.9,3.7,0.2,8.3,0.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160874526671681706660000009762059850372291464_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 60.9274,
    x2: 190,
    y2: 60.9274,
    gradientTransform: "matrix(1 0 0 -1 0 121)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A2A2A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E6E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160874526671681706660000009762059850372291464_)"
    },
    d: "M8.3,0h173.5c4.6,0,8.3,3.7,8.3,8.3v103.5 c0,4.6-3.7,8.3-8.3,8.3H8.3c-4.6,0-8.3-3.7-8.3-8.3V8.3C0,3.7,3.7,0,8.3,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.8,
    y: 68.1,
    className: "st4",
    width: 8,
    height: 8.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.9,
    y: 76.2,
    className: "st4",
    width: 8,
    height: 8.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.9,
    y: 60,
    className: "st4",
    width: 8,
    height: 8.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.9,
    y: 68.1,
    className: "st4",
    width: 8,
    height: 8.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.9,
    y: 51.9,
    className: "st4",
    width: 8,
    height: 8.1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.9,
    y: 43.8,
    className: "st4",
    width: 8,
    height: 8.1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 84.3,
    className: "st4",
    width: 8,
    height: 8.1
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.8,
    y: 84.3,
    className: "st4",
    width: 8,
    height: 8.1
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.8,
    y: 60,
    className: "st4",
    width: 8,
    height: 8.1
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.6,
    y: 43.8,
    className: "st4",
    width: 8,
    height: 8.1
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 27.6,
    className: "st4",
    width: 8,
    height: 8.1
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 68.1,
    className: "st4",
    width: 8,
    height: 8.1
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.7,
    y: 68.1,
    className: "st4",
    width: 8,
    height: 8.1
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.9,
    y: 51.9,
    className: "st4",
    width: 8,
    height: 8.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardNoIconGrey);
export default __webpack_public_path__ + "static/media/card_no-icon_grey.fd3df657ac9b52386e811f1a49880c7a.svg";
export { ForwardRef as ReactComponent };